<script>
import DelayedBitmap from 'linna/components/DelayedBitmap'
import Fade from 'linna/components/Fade'

import GlitchedImage from '../snippets/GlitchedImage'
import StyledButton from '../snippets/StyledButton'

export default {
  name: 'ImageFileViewer',

  components: {
    DelayedBitmap,
    Fade,
    GlitchedImage,
    StyledButton
  },

  props: {

    file: {
      type: Object,
      required: true
    },

    data: {
      required: true
    }

  },

  data () {
    return {
      isActivated: false
    }
  },

  methods: {

    onActivate () {
      this.isActivated = true
    }

  }

}
</script>

<template>
  <div
    :class="{
      'c-image-file-viewer-activated': isActivated,
      'c-image-file-viewer-not-activated': !isActivated
    }"
    class="c-image-file-viewer-image"
  >

    <div
      v-if="!isActivated"
      class="c-image-file-viewer-button"
    >
      <styled-button @click="onActivate">
        Load
      </styled-button>
    </div>

    <fade>
      <div class="c-image-file-viewer-content">

        <delayed-bitmap
          v-if="!isActivated"
          :src="data"
          class="c-image-file-viewer-placeholder"
        />

        <glitched-image
          v-else
          :src="data"
          class="c-image-file-viewer-image"
        />

      </div>
    </fade>

  </div>
</template>

<style lang="scss">

.c-image-file-viewer {
  @include fill-relative;
}

.c-image-file-viewer-content {
  @include fill;
}

.c-image-file-viewer-placeholder,
.c-image-file-viewer-image {
  @include fill-relative;
}

.c-image-file-viewer-button {
  @include keep-full-center;
  z-index: 3;
}

.c-image-file-viewer-not-activated {

  .c-image-file-viewer-content {
    filter: blur(1rem);
  }

}

.c-image-file-viewer-placeholder {
  @include radius-loose;
  object-fit: contain;
  z-index: 2;
  opacity: 0.2;
}

.c-image-file-viewer-image {
  z-index: 1;
  object-fit: contain;
}

</style>
